import { IApi } from '../../api'
import { IClientEmailGroupProvisionParams } from '../../api/clientEmailGroups'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'clientEmailGroups'

export const [
  GET_CLIENT_EMAIL_GROUP_REQUEST,
  GET_CLIENT_EMAIL_GROUP_SUCCESS,
  GET_CLIENT_EMAIL_GROUP_FAILURE,
] = createRequestTypes(prefix, 'GET_CLIENT_EMAIL_GROUP')

export const [
  PROVISION_CLIENT_EMAIL_GROUP_REQUEST,
  PROVISION_CLIENT_EMAIL_GROUP_SUCCESS,
  PROVISION_CLIENT_EMAIL_GROUP_FAILURE,
] = createRequestTypes(prefix, 'PROVISION_CLIENT_EMAIL_GROUP')

export const [
  DELETE_CLIENT_EMAIL_GROUP_REQUEST,
  DELETE_CLIENT_EMAIL_GROUP_SUCCESS,
  DELETE_CLIENT_EMAIL_GROUP_FAILURE,
] = createRequestTypes(prefix, 'DELETE_CLIENT_EMAIL_GROUP')

export const getClientEmailGroup = createAction(
  (clientId: string, params: { skipLoader?: boolean } = {}) => ({
    type: [
      GET_CLIENT_EMAIL_GROUP_REQUEST,
      GET_CLIENT_EMAIL_GROUP_SUCCESS,
      GET_CLIENT_EMAIL_GROUP_FAILURE,
    ] as [string, string, string],
    promise: (api: IApi) => api.clientEmailGroups.get(clientId),
    params,
  }),
)

export const provisionClientEmailGroup = createAction(
  (clientId: string, data: IClientEmailGroupProvisionParams) => ({
    type: [
      PROVISION_CLIENT_EMAIL_GROUP_REQUEST,
      PROVISION_CLIENT_EMAIL_GROUP_SUCCESS,
      PROVISION_CLIENT_EMAIL_GROUP_FAILURE,
    ] as [string, string, string],
    promise: (api: IApi) => api.clientEmailGroups.provision(clientId, data),
  }),
)

export const deleteClientEmailGroup = createAction((clientId: string) => ({
  type: [
    DELETE_CLIENT_EMAIL_GROUP_REQUEST,
    DELETE_CLIENT_EMAIL_GROUP_SUCCESS,
    DELETE_CLIENT_EMAIL_GROUP_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.clientEmailGroups.delete(clientId),
}))
